import { SVGProps, Ref, forwardRef } from 'react';

export const IndexSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.5 8.073C.5 3.895 3.853.5 8 .5s7.5 3.395 7.5 7.573c0 4.177-3.353 7.573-7.5 7.573S.5 12.25.5 8.073M8 1.5c-3.585 0-6.5 2.938-6.5 6.573s2.915 6.573 6.5 6.573 6.5-2.938 6.5-6.573S11.585 1.5 8 1.5"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.667 5.45a.735.735 0 0 0-.734.737.735.735 0 1 0 .734-.736"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.333 5.45a.735.735 0 0 0-.733.737.735.735 0 1 0 .733-.736"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.014 9.51a.5.5 0 0 1 .67.229 3.7 3.7 0 0 0 3.315 2.08c1.404 0 2.69-.804 3.315-2.08a.5.5 0 0 1 .898.44A4.7 4.7 0 0 1 8 12.82a4.7 4.7 0 0 1-4.214-2.64.5.5 0 0 1 .23-.669"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
IndexSolidSize16Glyph.displayName = 'IndexSolidSize16Glyph';
